import React, { MouseEvent } from 'react'
import { MetaItem } from './Overview'
import { Icon } from '@waylay/react-components'

interface ITag {
  label: string
  onClick?: (event: MouseEvent<HTMLDivElement>) => void
}

const Tag = ({ label, onClick = () => {} }: ITag) => (
  <MetaItem {...{ label, onClick }} style={{ marginRight: '0.5rem' }}>
    <Icon name="local_offer" />
    {label}
  </MetaItem>
)

export default Tag
